import { ComposedElement } from "../ComposedElement.mjs";
export var TableNode;

(function (TableNode) {
  TableNode.TYPE = 'table';
  var TableHeader;

  (function (TableHeader) {
    TableHeader["FIRST_ROW"] = "first_row";
    TableHeader["FIRST_COLUMN"] = "first_column";
  })(TableHeader = TableNode.TableHeader || (TableNode.TableHeader = {}));

  function isTableNode(value) {
    return ComposedElement.isComposedElement(value, TableNode.TYPE);
  }

  TableNode.isTableNode = isTableNode;

  function validateTableNode(value, validateChildNode) {
    var isValid = ComposedElement.validateComposedElement(value, TableNode.TYPE, validateChildNode);
    return isValid ? value : null;
  }

  TableNode.validateTableNode = validateTableNode;
})(TableNode || (TableNode = {}));

export var TableRowNode;

(function (TableRowNode) {
  TableRowNode.TYPE = 'table-row';

  function isTableRowNode(value) {
    return ComposedElement.isComposedElement(value, TableRowNode.TYPE);
  }

  TableRowNode.isTableRowNode = isTableRowNode;

  function validateTableRowNode(value, validateChildNode) {
    var isValid = ComposedElement.validateComposedElement(value, TableRowNode.TYPE, validateChildNode);
    return isValid ? value : null;
  }

  TableRowNode.validateTableRowNode = validateTableRowNode;
})(TableRowNode || (TableRowNode = {}));

export var TableCellNode;

(function (TableCellNode) {
  TableCellNode.TYPE = 'table-cell';

  function isTableCellNode(value) {
    return ComposedElement.isComposedElement(value, TableCellNode.TYPE);
  }

  TableCellNode.isTableCellNode = isTableCellNode;

  function validateTableCellNode(value, validateChildNode) {
    var isValid = ComposedElement.validateComposedElement(value, TableCellNode.TYPE, validateChildNode);
    return isValid ? value : null;
  }

  TableCellNode.validateTableCellNode = validateTableCellNode;
})(TableCellNode || (TableCellNode = {}));